import React, { useState } from 'react';
import Title from '@/components/title';
import { ISearchMediaReq, ISearchMediaRes } from '@/interfaces/media';
import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { searchMedias } from '@/adapters/media';
import MediaCard from '@/components/card/media-card';
import SubMenu from '@/components/menu/sub-menu';
import { ProductMenu } from '@/configs/menuItems';
import { getPathSegment } from '@/utils/pathUtils';
import Card from '@/components/card';
import { isManager } from '@/utils/permissionUtils';

const _criteria: ISearchMediaReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  modelType: 'product-allocation',
};

const ProductAllocationFiles: React.FC = () => {
  const pathSegment = getPathSegment();
  const [criteria] = useState<ISearchMediaReq>({
    ..._criteria,
    modelId: 1,
  });

  const { data: medias, refetch } = useQuery<
    AxiosResponse<ISearchMediaRes>,
    Error
  >({
    queryKey: ['search-media', criteria],
    queryFn: async () => await searchMedias(criteria),
  });

  const documents = medias?.data?.data || [];

  return (
    <>
      <SubMenu active={pathSegment} items={ProductMenu} />
      <Card customClass="min-h-[200px]">
        <Title title="Product Allocations Files"></Title>
        <div className="flex flex-col gap-3">
          {documents.map(d => {
            return (
              <MediaCard
                key={d.id}
                media={d}
                onDeleted={() => refetch()}
                isDownload
                readonly={!isManager()}
              />
            );
          })}
        </div>
      </Card>
    </>
  );
};

export default ProductAllocationFiles;
